import { InputMask } from '@/libs/input_mask/index'

window.InputMask = InputMask

export class MaskedInput {
  public static reinit(): InputMask {
    return new InputMask()
  }

  public constructor() {
    this.init()
  }

  public init(): void {
    MaskedInput.reinit()
  }
}
